// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const boltund: PokeData = {
  "id": 836,
  "name": "boltund",
  "height": 10,
  "weight": 340,
  "base_experience": 172,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "bite",
    "roar",
    "charm",
    "spark",
    "crunch",
    "charge",
    "wild-charge",
    "electrify",
    "play-rough",
    "electric-terrain",
    "nuzzle"
  ],
  "moves": [
    "tackle",
    "bite",
    "crunch",
    "wild-charge",
    "play-rough",
    "electric-terrain",
    "volt-crash",
    "quick-tempo",
    "thunderbolt",
    "volt-switch",
    "thunder-fang",
    "thunder-punch",
    "zap-cannon"
  ],
  "evolution_chain": {
    "id": 440,
    "item": null,
    "species": [
      {
        "name": "yamper",
        "order": 835,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "boltund",
        "order": 836,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 835,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 94,
    "speed": 176,
    "ability_power": 131
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
